"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _react = _interopRequireWildcard(require("react"));

var _reactDropzone = require("react-dropzone");

var _propTypes = require("prop-types");

var _uuid = require("uuid");

var _elements = require("../../styles/elements");

var _strings = require("../../util/strings");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var user = {
  firstName: 'Unknown'
};

var AddAttachments = function AddAttachments(_ref) {
  var className = _ref.className,
      onAttachmentsChange = _ref.onAttachmentsChange,
      onUploadFile = _ref.onUploadFile,
      maxSize = _ref.maxSize,
      disabled = _ref.disabled;
  // Handle getting accepted files
  var handleDrop = (0, _react.useCallback)(function (files) {
    if (!files.length) return;
    files.forEach(function (item) {
      var attachment = {
        id: (0, _uuid.v4)(),
        name: item.name,
        type: item.type,
        size: item.size,
        progress: 0,
        added: Date.now(),
        uploader: user
      };
      onAttachmentsChange(function (prevAttachments) {
        return [].concat((0, _toConsumableArray2["default"])(prevAttachments), [attachment]);
      });
      onUploadFile(attachment.id, item);
    });
  }, [onAttachmentsChange, onUploadFile]); // Handle getting rejected files

  var handleReject = (0, _react.useCallback)(function (fileRejections) {
    var errorList = fileRejections.map(function (item) {
      var err = item.errors[0];
      var error = err.code === 'file-too-large' ? "Attachment too large (max size ".concat((0, _strings.humanFileSize)(maxSize), ")") : err.message;
      return {
        error: error,
        id: (0, _uuid.v4)(),
        name: item.file.name,
        type: item.file.type,
        size: item.file.size
      };
    });
    onAttachmentsChange(function (prevAttachments) {
      return [].concat((0, _toConsumableArray2["default"])(prevAttachments), (0, _toConsumableArray2["default"])(errorList));
    });
  }, [onAttachmentsChange, maxSize]);

  var _useDropzone = (0, _reactDropzone.useDropzone)({
    noClick: true,
    // click button to trigger open, so noClick for container
    noDrag: true,
    // no drag & drop, click button to upload
    multiple: true,
    // allow multiple files
    maxSize: maxSize,
    onDropAccepted: handleDrop,
    onDropRejected: handleReject
  }),
      getRootProps = _useDropzone.getRootProps,
      getInputProps = _useDropzone.getInputProps,
      open = _useDropzone.open;

  return (0, _jsxRuntime.jsxs)("div", _objectSpread(_objectSpread({
    className: className
  }, getRootProps()), {}, {
    children: [(0, _jsxRuntime.jsx)("input", _objectSpread({}, getInputProps())), (0, _jsxRuntime.jsx)("div", {
      className: "grui flex justify-between",
      children: (0, _jsxRuntime.jsx)("button", {
        type: "button",
        onClick: open,
        disabled: disabled,
        css: [_elements.button.styles.link, _elements.text.styles.textSm, _elements.text.styles.textPrimary, process.env.NODE_ENV === "production" ? "" : ";label:AddAttachments;"],
        children: "+ Add attachment"
      })
    })]
  }));
};

AddAttachments.propTypes = {
  className: _propTypes.string,
  onAttachmentsChange: _propTypes.func,
  onUploadFile: _propTypes.func,
  maxSize: _propTypes.number,
  disabled: _propTypes.bool
};
AddAttachments.defaultProps = {
  className: undefined,
  onAttachmentsChange: function onAttachmentsChange() {},
  onUploadFile: function onUploadFile() {},
  maxSize: 20971520,
  // 20mb
  disabled: false
};
var _default = AddAttachments;
exports["default"] = _default;
//# sourceMappingURL=AddAttachments.js.map